/** ----------------------------------------
    Imports
---------------------------------------- */

import anime from 'animejs';
import axios from 'axios';

/** ----------------------------------------
     Map Filter
 ---------------------------------------- */

export class ProjectFilter {

    constructor() {
        this.containerEl = document.getElementById('projects-overview');

        if (!this.containerEl)
            return;

        this.resultsEl = document.getElementById('projects-results');
        this.paginationEl = document.querySelector('#js-pagination');
        this.amountEl = document.getElementById('projects-amount');
        this.resetEl = document.querySelector('#reset-button');
        this.mapFilterEl = document.querySelector('.map-filter');
        this.searchInput = document.querySelector('#filter-search');
        this.filterInputEls = document.querySelectorAll('.js-filter-form input');
        this.endpoint = `${ window.location.origin }/api/projects`;
        
        this.params = {};

        this._init();
    }

    /** ----------------------------------------
        Parse URL Params
    ---------------------------------------- */

    parseUrlParams() {
        let paramsStrings = decodeURIComponent(window.location.hash)
            .substring(1)
            .split('&');
        
        paramsStrings.forEach(paramString => {
            if (paramString) {
                let split = paramString.split('=');
                if (split[1]) {
                    let value = split[1].split(',');
                    if (value.length === 1) value = value[0];
                    this.params[split[0]] = value;
                }
            }
        });
    }

    /** ----------------------------------------
        Get Query
    ---------------------------------------- */

    getQuery() {
        const esc = encodeURIComponent;
        const query = Object.keys(this.params)
            .map((k) => esc(k) + '=' + esc(this.params[k]))
            .join('&');
        return query;
    }

    /** ----------------------------------------
        Set input values by params
    ---------------------------------------- */

    setInputValuesByParams() {
        Object.keys(this.params).forEach(param => {
            this.filterInputEls.forEach(inputEl => {
                if (param === inputEl.name && this.params[param] === inputEl.value) {
                    inputEl.click();
                    window.addEventListener('load', () => {
                        this.scrollToResults();
                    });
                }
            });
        });
    }

    /** ----------------------------------------
        Clear/Update DOM
    ---------------------------------------- */

    updateResultsDom(data) {
        this.amountEl.innerHTML = data.total;
        this.resultsEl.innerHTML = data.dom;
        this.paginationEl.innerHTML = data.pagination;
    }

    /** ----------------------------------------
        Get Projects
    ---------------------------------------- */

    getProjects() {
        if (this.fetching) return;

        this.fetching = true;
        this.paginationEl.classList.add('is-loading');

        const query = this.getQuery();
        const url = `${ this.endpoint }?${query}`;

        if (query)
            window.location.hash = query;

        return axios.get(url).then(response => {
            this.fetching = false;
            this.paginationEl.classList.remove('is-loading');
            return response.data;
        });
    }

    /** ----------------------------------------
        Filter
    ---------------------------------------- */

    filter() {
        this.getProjects().then(data => {
            this.updateResultsDom(data);
            this.applyPaginationListener();
        });
    }

    /** ----------------------------------------
        Handle province map filter
    ---------------------------------------- */

    applyMapListener() {
        this.mapFilterEl.addEventListener('MapFilterChanged', (event) => {
            this.params.province = event.detail;
            this.filter();
        });
    }

    /** ----------------------------------------
        Handle search filter
    ---------------------------------------- */

    applySearchListener() {
        let timeout = null;

        this.searchInput.addEventListener('keydown', () => {
            clearTimeout(timeout);
            timeout = setTimeout(() => {
                this.params.search = this.searchInput.value;
                this.filter();
            }, 500);
        });
    }

    /** ----------------------------------------
        Handle load more
    ---------------------------------------- */

    applyPaginationListener() {
        this.paginationElems = this.paginationEl.querySelectorAll('a');

        [...this.paginationElems].forEach(pageEl => {
            pageEl.addEventListener('click', event => {
                event.preventDefault();
                this.params.page = pageEl.dataset.page;
                this.filter();
                this.scrollToResults();
            });
        });
    }

    /** ----------------------------------------
        Handle dropdown filters
    ---------------------------------------- */

    applyInputListeners() {
        this.filterInputEls.forEach(inputEl => {
            inputEl.addEventListener('change', () => {
                this.params.page = 0;
                this.params[inputEl.name] = inputEl.checked ? inputEl.value : '';
                this.filter();
                this.scrollToResults();
            });
        });
    }

    /** ----------------------------------------
        Handle reset
    ---------------------------------------- */

    applyResetListeners() {
        this.resetEl.addEventListener('click', () => {
            event.preventDefault();
            window.location = window.location.origin + window.location.pathname + '?c=' + (new Date()).valueOf() + '#projects-overview';
        });
    }

    scrollToResults() {
        const scrollElement = window.document.scrollingElement || window.document.body || window.document.documentElement;
        const scrollTo = this.containerEl.getBoundingClientRect().top + scrollElement.scrollTop - 160;
        anime({
            targets: scrollElement,
            scrollTop: scrollTo,
            duration: 500,
            easing: 'easeInOutQuad'
        });
    }

    /** ----------------------------------------
        Init
    ---------------------------------------- */

    _init() {
        this.parseUrlParams();
        this.setInputValuesByParams();
        this.applyMapListener();
        this.applySearchListener();
        this.applyInputListeners();
        this.applyResetListeners();
        this.filter();
    }
}
